<template>
  <div v-show="p_active" class="c2_2_1">
    <div class="divSearch">
      <p class="pError">{{ errMsg }}</p>
      <div class="divBox250">
        <p>当前期间：</p>
        <input v-model="editRow.fperiod" type="month" valueFormat="yyyy-MM">
      </div>
      <div class="divBox150">
        <button :disabled="bbSave" @click="save(22)"><i v-show="bbSave" class="el-icon-loading"/> 结账</button>
        <button :disabled="bbSave" @click="getDs"><i v-show="bbSave" class="el-icon-loading"/> 刷新</button>
      </div>
    </div><!--查询-->
    <div :style="[{'width':(mainWidth-195)+'px'},{'height':(mainHeight-180)+'px'}]" class="divList">
      <table v-if="errRows.length===0" class="tbList">
        <thead>
          <tr class="tbListHead"><!-- class="editTbHead"-->
            <th style="width: 15%;"/>
            <th style="width: 60%;">期间</th>
            <th/>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row,idx) in tbData"
            v-if="row.fid>0"
            :key="idx"
            :class="idx===idTr || idx===idTrCk?'trOver':''"
            @mouseout="trOut"
            @mouseover="trOver(idx)"
            @mousedown="trClick(idx)">
            <td class="tdIdx">{{ idx+1 }}</td>
            <td>{{ row.fperiod }}</td>
            <td><button v-if="idx===0" @click="save(2,row.fperiod)">反结账</button></td>
          </tr>
        </tbody>
      </table>
      <table v-if="errRows.length>0" class="tbList">
        <thead>
          <tr>
            <td colspan="3" style="font-weight:bold;color:blue;">存在以下问题，请先处理：</td>
          </tr>
        </thead>
        <tr v-for="mm in errRows" :key="mm.fid">
          <td>{{ mm.fcode }}</td>
          <td>{{ mm.fname }}</td>
          <td>{{ mm.ferror }}</td>
        </tr>
      </table>
    </div><!--列表-->
  </div>
</template>
<script type="text/javascript">
import CEdit from './02_edit.vue'
import CPrint from './04_view.vue'
import MsgBox from '../c2_info/06_msgBox.vue'
import dtUtil from '../../utils/dateUtil'
export default{
  name: 'CList',
  components: {
    CPrint,
    MsgBox,
    CEdit
  },
  props: {
    p_id: {
      type: Number,
      default: 0
    }, /**/
    p_title: {
      type: String,
      default: '欢迎使用'
    },
    p_iAct: {
      type: Number,
      default: 21
    },
    p_active: {
      type: Boolean,
      default: false
    },
    p_url: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      bbSave: false,
      errMsg: '',
      idTr: 0,
      idTrCk: 0,
      errRows: [],
      editRow: {},
      searchRow: {},
      mainWidth: 1000,
      mainHeight: 500,
      tbData: [],
      roles: []
    }
  },
  watch: {
  },
  mounted() {
    const my = this
    this.mainWidth = this.$getWH().orgW
    this.mainHeight = this.$getWH().orgH
    window.onresize = () => {
      return (() => {
        my.mainWidth = document.body.clientWidth
        my.mainHeight = document.body.clientHeight
      })()
    }
  },
  created: function() {
    this.getDs()
  },
  methods: {
    prt(a, b) {
      console.log(`10_icperiod.${a}`, b)
    },
    getDs() {
      this.errRows = []
      this.searchRow['iAct'] = this.p_iAct
      this.$jPost(this.p_url, this.searchRow, rs => { // + '/find'
        this.tbData = rs.data.data.sort(this.comm.sortArr('fid', false))
        const dt = new Date(this.tbData[0].fperiod + '-01')
        dt.setMonth(dt.getMonth() + 1)
        this.editRow.fperiod = dtUtil.dtFmt(dt, 'yyM')
        this.prt('getDs.tbData', this.editRow)
      })
    },
    trOver(idTr) {
      this.idTr = idTr
    },
    trOut() {
      this.idTr = -1
    },
    trClick(idTr) {
      if (idTr === this.idTrCk) {
        this.idTrCk = -1
      } else {
        this.idTrCk = idTr
      }
    },
    save(iAct, fperiod) {
      this.editRow['iAct'] = iAct
      if (fperiod) this.editRow['fperiod'] = fperiod
      this.$jPost(this.p_url, this.editRow, rs => { // + '/find'
        this.prt('save', rs)
        this.errRows = rs.data
        return
      })
      /**      this.bbSave = true
      this.editRow['iAct'] = iAct
      this.$jPost(this.p_url, this.editRow, rs => { // + '/find'
        this.prt('save', rs)
        this.bbSave = false
        this.getDs()
      }) */
    }
  }
}
</script>
<style scoped>
a{
  color: rgba(0, 0, 255, 0.664);
}
.c2_2_1{
  position: relative;
  padding: 10px;
  overflow: hidden;/* */
  border: 1px solid rgba(224, 210, 210, 0.281);
  color: rgba(77, 69, 69, 0.877);
  /**;background-color: blue; */
}
.divSearch{
  position: relative;
  float: right;
  margin-bottom: 15px;
}
.pError{
  color:red
}
.divList{
  width: 100%;
  overflow: auto;/* */
  min-height: 350px;
}
.divBox250{
  width: 280px;
  display: flex;
  flex-direction: row;
  float: left;
  text-align: right;
  margin-bottom: 3px;
}
.divBox250 p{
  width: 43%;
  margin-right: 2%;
  float: left;
}
.divBox250 input{
  width: 55%;
  height: 20px;
  float: left;
  padding: 0 5px;
}
.divBox150{
  width: 150px;
  display: flex;
  flex-direction: row;
  float: left;
  text-align: center;
}
.divBox150 button{
  width: 45%;
  margin-left:10px;
}
.picker{
  width: 250px;
  border: 1px solid blue;
  padding: 3px;
  border-radius: 2px;
}
.tbList{
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  position: relative;
}
.tbList td{
  border: 1px solid rgba(168, 168, 168, 0.103);
  padding: 2px 15px;
  text-align: left;
}
.iptChkBox{
  width: 17px;
}
.trOver{
  /* background-image: linear-gradient(rgb(234, 249, 255),rgba(216, 216, 216, 0.308),rgb(234, 249, 255));
  */
  background-color: rgba(7, 70, 95, 0.774);
  color:white;
}
.trOver a{
  color:white;
}
.trOver :hover{
  cursor: pointer;
}
.tbListHead th{
  border: 1px solid rgba(168, 168, 168, 0.103);
  font-weight: normal;
  padding: 5px 2px;
  background-image: linear-gradient(white,rgb(233, 233, 233),rgb(240, 240, 240),rgb(233, 233, 233),white);/**rgba(153, 153, 153, 0.096) */
  text-align: center;
  position: sticky;
  top:0px;
}

.editTbFoot{
  text-align: center;
  position: sticky;
  bottom:0px;
}
.editTbFoot th{
  border: 1px solid rgba(168, 168, 168, 0.103);
  font-weight: normal;
}
.tdIdx{
  width: 10px;
}

</style>



// WEBPACK FOOTER //
// src/comps/c2_info/10_icperiod.vue